<template>
	<div class="contain_vip" :class="{'pb-30': padShow }">
		
		

		<div class="ptlr-16">
			<!-- <div class="flexs mb-10" style="justify-content:center;margin-top:150px;margin-bottom:30px;">
				<div class="title_line wh_3_15"></div>
				<div class="fw-500 fz-20 c1 ml-8">{{price}}</div>
			</div> -->

			<!-- <div v-if="data.MembersExplain" v-html="data.MembersExplain"></div> -->
		</div>
		<ul class="flexs flex-center" style="margin-top:150px;">
      		<li class="every_vip text-center pt-15 box-s vip_active">
				<div class="c1 fz-15 fw-500 mtb-17 ">￥<span class="fw-600 fz-26 l-h-21">{{name}}</span> </div>
				<div class="fz-15 l-h-15 c6">购买价格:{{price}}</div>
			</li>
		</ul>
		<div class="flexs flex-jus p-fixed_bottom bg_f box-shaw1 pd-15 box-s">
			<div class="flexs fz-15">
				<div class="c1">支付金额：</div>
				<div class="c6 fw-600">{{price}}元</div>
			</div>
			<div class="vip_btn" @click="submit">立即开通</div>
		</div>
		<loading :loadFlag="loadFlag"></loading>
	</div>
</template>

<script>
	import {getShowPadding} from "@/utils/common.js";
	import {buyTest} from "@/api/api.js";
	import loading from "@/components/loading"
	import wx from "weixin-js-sdk";
	export default {
		components: {
			loading
		},
		data() {
			return {
				id:'',
				name:'',
				price: 0,
				loadFlag: false,
        		padShow: false,
				
				show: false,
				payData:{},
				type:1,//1真题试卷 2模拟试卷
			}
		},
		created() {
			if(this.$route.query.id) this.id = this.$route.query.id
			if(this.$route.query.name) this.name = this.$route.query.name
			if(this.$route.query.price) this.price = this.$route.query.price
			if(this.$route.query.type) this.type = this.$route.query.type
      		this.getChange()
		},
		mounted(){
			this.padShow = getShowPadding()
		},
		computed: {
			
		},
		methods: {
			
		submit(){
			// let { appId, nonceStr, package, paySign, signType, timeStamp } = this.payData
      		wx.ready(() => {
				wx.chooseWXPay({
					appId:this.payData.appId, 
					timestamp: this.payData.timeStamp, 
					nonceStr:this.payData.nonceStr, 
					package: this.payData.package, 
					signType:this.payData.signType, 
					paySign:this.payData.paySign, 
					success: (res) => {
						console.log(res,'99')
						if (res.errMsg === "chooseWXPay:ok") {
              				this.$toast('支付成功')
							localStorage.setItem('indexFlag', 1)
							setTimeout(()=>{
                				this.$router.replace('/member')
							}, 1000)
						}
					},
					complete: (res) => {
						console.log(res,'9933')
						// 调用完成时的回调：成功或失败都会执行
						if (res.errMsg === "chooseWXPay:ok") {
							this.$toast.success('支付成功')
							localStorage.setItem('indexFlag', 1)
							localStorage.setItem('merFlag', 1)
							setTimeout(()=>{
                				this.$router.replace('/member')
							}, 1000)
							console.log("complete支付成功:", res);
						}
						else if (res.errMsg === "chooseWXPay:cancel") {
							console.log("complete取消支付:",res);
						} else if (res.errMsg === "chooseWXPay:fail") {
							this.$toast('支付失败')
							console.log("complete支付失败:",res);
						}
					},
					fail: (res) => {
						this.$toast('支付失败')
						console.log(res,'9955')
					},
					cancel: (res) => {
						console.log(res,'99000')
					},
				});
			})
			wx.error(function(res){
				console.log(res,999888)
			});
		},

		async getChange(id) {
			const res = await buyTest({ id: this.id , type: this.type })
			if(res.code == 1000){
				const data = res.data
				this.payData = data
				wx.config({
					debug: false, // 开启调试模式
					appId: data.appId, // appId 必填，公众号的唯一标识
					timestamp: "" + data.timeStamp, // 必填，生成签名的时间戳
					nonceStr: data.nonceStr, // 必填，生成签名的随机串
					signature: data.paySign, // 必填，签名
					jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
				});

			} else {
				this.$toast(res.msg)
			}
		}
		}
	}
</script>

<style scoped lang="less">
  .contain_vip {
		overflow-x: hidden;
	}
	.sw_contain {
		padding-top: 20px;
		margin: 0 45px 25px;
	}
	.swiper-container {
		width: 100%;
		height: 146px;
		overflow: visible !important;
	}

	.swiper-container .swiper-wrapper .swiper-slide {
		width: 285px;
		border-radius: 6px;
		padding: 0 10px;
	}

	.swiper-container .swiper-wrapper .swiper-slide img {
	  width: 285px;
		height: 146px;
		border-radius: 6px;
	}

	.swiper-container .swiper-wrapper .swiper-slide-prev {
		margin-top: 8px;
		height: 130px !important;

	}

	.swiper-container .swiper-wrapper .swiper-slide-prev img {
		height: 130px !important;
	}

	.swiper-container .swiper-wrapper .swiper-slide-next {
		margin-top: 8px;
		height: 130px !important;
	}

	.swiper-container .swiper-wrapper .swiper-slide-next img {
		height: 130px !important;
	}

	.swiper-container .swiper-wrapper .swiper-slide-active {
		width: 285px;
		/* margin: 0 20px; */
	}

	.inner_contain {
		position: absolute;
		left: 24px;
		top: 26px;
		color: #fff;
	}

	.img_po {
		position: absolute;
		right: 24px;
		bottom: 15px;
		width: 33px !important;
		height: 31px !important;
	}

	.every_vip {
		width: 303px;
		height: 115px;
		background: #FFFFFF;
		border-radius: 6px;
		border: 1px solid #E0E0E0;
		margin-right: 13px;

		&:last-child{
			margin-right: 0;
		}
	}

	.vip_active {
		background: rgba(73, 124, 255, 0.05);
    border: 1px solid #497CFF;
	}

	.vip_btn {
		width: 157px;
		height: 50px;
		line-height: 50px;
		background: #497CFF;
		box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.06);
		border-radius: 6px;
		text-align: center;
		font-size: 15px;
		font-weight: 600;
		color: #FFFFFF;
	}

</style>